import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-es";

export const unique = (): string => {
  return uuidv4();
};
export const sleep = (ms: number):Promise<void> => {
  return new Promise(resolve => {
    setTimeout(() => resolve(), ms);
  });
}

export const getCookie = (name:string): string | null=> {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}

export const srcToFile = (src:string, fileName:string, mimeType:string) => {
  return (fetch(src)
      .then(function (res) {return res.arrayBuffer();})
      .then(function(buf:any) { return new File([buf], fileName, {type:mimeType}); })
  );
}

export const LertamRCFormat = {
  stringify: function (cipherParams: CryptoJS.lib.CipherParams) {
    var j: (string | null)[] = [
      cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
    ];
    j.push(cipherParams.iv ? cipherParams.iv.toString() : null);
    j.push(cipherParams.salt ? cipherParams.salt.toString() : null);
    return j.join("-");
  },
  parse: function (jsonStr: string) {
    var j = jsonStr.split("-");
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j[0]),
    });
    if (j[1] !== null) cipherParams.iv = CryptoJS.enc.Hex.parse(j[1]);
    if (j[2] !== null) cipherParams.salt = CryptoJS.enc.Hex.parse(j[2]);
    return cipherParams;
  },
};

export const decrypt = async (encrypted: string) => {
  let decrypted = CryptoJS.AES.decrypt(encrypted, "password", {
    format: LertamRCFormat,
  });
  try {
    let result = decodeURIComponent(decrypted.toString(CryptoJS.enc.Utf8));
    return JSON.parse(result);
  } catch (err) {
    throw err;
  }
};

export const sendRequest = (
  module: string,
  action = "index",
  method = "GET",
  params = {},
  body = null,
  headers = null
) => {
  return new Promise((resolve, reject) => {
    let options: any = { method, credentials: "same-origin" };
    if (body !== null) options.body = body;
    if (headers !== null) options.headers = headers;
    let payload = { module, action, params };
    console.log(`Sended ${module}.${action}`, params, body);
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), "password", {
      format: LertamRCFormat,
    });
    fetch(
      `/api/${encodeURIComponent(encodeURIComponent(encrypted.toString()))}`,
      options
    )
      .then(async (res) => {
        const enc = await res.text();
        return await decrypt(enc);
      })
      .then((res) => {
        console.log(`Got ${module}.${action}`, res);
        if (res.success) return resolve(res.data);
        else throw new Error(res.error);
      })
      .catch((err) => {
        if (err.message === "Access denied")
          alert("Сессия окончена! Перезагрузите страницу");
        else alert("Что-то пошло не так");
        console.error(err);
      });
  });
};

export const mapNames = (name: string, mult:boolean = true): string => {
  switch (name) {
    case "covering":
      return mult ? "Покрытия" : 'Покрытие';
    case "tombstone":
      return mult ? "Цветники" : 'Цветник';
    case 'fence':
      return mult ? 'Ограды' : 'Ограда';
    case 'accessory':
      return mult ? 'Аксессуары' : 'Аксессуар';
    case 'monument':
      return mult ? 'Памятники' : 'Памятник';
    case 'element':
      return mult ? 'Элементы' : 'Элемент';
      case 'group':
      return mult ? 'Группы' : 'Группа';
    default:
      return "Unknown type";
  }
};